import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Message, Margin } from "~/components/elements";
import { BoxInput, SelectInput } from "./styles";
import theme from "~/styles/theme";

export default function Select({
  id,
  onChange,
  errors,
  label,
  htmlFor,
  name,
  value,
  onBlur,
  options,
  placeholder,
  disabled,
  required,
}) {
  useEffect(() => {
    if (value && value.length > 0) {
      onChange(name, { value, label: value });
    }
  }, [name, onChange, value]);

  const getColor = (data) => {
    if (data.isSelected) {
      return theme.palette.neutral.primary.light;
    }

    if (data.isFocused) {
      return theme.palette.neutral.primary.light;
    }

    return theme.palette.neutral.primary.key;
  };

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      color: state.selectProps.menuColor,
      borderColor: theme.palette.brand.primary.key,
    }),
    option: (provided, state) => ({
      ...provided,
      color: getColor(state),
    }),
    selectOption: (provided, state) => ({
      ...provided,
      color: getColor(state),
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: disabled ? theme.palette.neutral.primary.dark : theme.palette.neutral.primary.key,
      // padding: "10px 0 0",
    }),
    // indicatorsContainer: (provided, state) => ({
    //   ...provided,
    //   padding: "14px",
    // }),
  };

  return (
    <BoxInput>
      <label htmlFor={htmlFor}>
        <strong>
          {label}
          {required && label ? <sup>*</sup> : ""}
        </strong>
      </label>

      <SelectInput
        isDisabled={disabled}
        components={{
          IndicatorSeparator: () => null,
        }}
        onChange={(val) => onChange(name, val)}
        onBlur={onBlur(name, true)}
        noOptionsMessage={() => "..."}
        value={value}
        placeholder={placeholder}
        options={options}
        id={id}
        styles={customStyles}
        theme={(items) => ({
          ...items,
          borderRadius: "0",
          spacing: {
            controlHeight: 48,
            menuGutter: 2,
            baseUnit: 6,
          },
          colors: {
            ...items.colors,
            neutral20: !!errors
              ? theme.palette.feedback.error.key
              : theme.palette.neutral.primary.dark, //select border
            neutral30: theme.palette.neutral.primary.dark, //hover select border
            neutral80: theme.palette.neutral.primary.key, //text color option selected
            primary25: theme.palette.brand.primary.key, //background option selected
            primary50: theme.palette.brand.primary.key, //background option selected
            primary: theme.palette.brand.primary.key, //hover options
          },
        })}
      />

      {!!errors && (
        <Margin mt={1}>
          <Message variant="error">{errors.value}</Message>
        </Margin>
      )}
    </BoxInput>
  );
}

Select.defaultProps = {
  id: "",
  disabled: false,
  htmlFor: "",
  onBlur: () => {},
  errors: "",
  label: "",
  value: {
    value: 0,
    label: "",
  },
};

Select.propTypes = {
  id: PropTypes.string,
  htmlFor: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  errors: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      label: PropTypes.string,
    }),
    PropTypes.string,
  ]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      label: PropTypes.string,
    })
  ).isRequired,
};
